import { ReactElement } from 'react';
import { ReactComponent as EditIcon } from '@elementary/common-ui/assets/16x16/edit.svg';
import { ReactComponent as PinIcon } from '@elementary/common-ui/assets/16x16/pin.svg';
import Menu from '../../Menu';
import SvgIcon from '../../SvgIcon';
import useTogglePin from '../hooks/useTogglePin';

type Props = {
  menuButton: ReactElement;
  sessionId: string;
  isPinned: boolean;
  canRename?: boolean;
  onRename: () => void;
};

const RENAME = 'rename';
const TOGGLE_PIN = 'toggle-pin';

const ChatRowMenu = ({
  menuButton,
  sessionId,
  isPinned,
  canRename = true,
  onRename,
}: Props) => {
  const { mutate: togglePin } = useTogglePin();

  const handleChange = (value: string) => {
    if (value === RENAME) {
      onRename();
    } else if (value === TOGGLE_PIN) {
      togglePin({ sessionId, pinned: !isPinned });
    }
  };

  return (
    <span onClick={(e) => e.stopPropagation()}>
      <Menu
        menuButton={menuButton}
        options={[
          ...(canRename
            ? [
                {
                  value: RENAME,
                  label: 'Rename',
                  icon: (
                    <SvgIcon width={16}>
                      <EditIcon />
                    </SvgIcon>
                  ),
                },
              ]
            : []),
          {
            value: TOGGLE_PIN,
            label: isPinned ? 'Unpin' : 'Pin',
            icon: (
              <SvgIcon width={16}>
                <PinIcon />
              </SvgIcon>
            ),
          },
        ]}
        onChange={handleChange}
        closeOnChange
      />
    </span>
  );
};

export default ChatRowMenu;
